module.exports = __webpack_public_path__ + "newstatic/img/two-sdk.6ace0fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/two-sdk.png
// module id = bUFp
// module chunks = 1